// ACF BLOCKS
// ===================================================

var acf_blocks = {

    settings: {
        content_columns: $('.block-content-columns'),
        expandable_content: $('.block-expandable-content'),
        featured_posts: $('.block-posts-featured'),
        history_timeline_slider: $('.block-history-timeline'),
        history_timeline_content_sliders: $('.block-history-timeline .content-slider'),
        location_media_text: $('.block-location-media-text .swiper'),
        location_people_display: $('.block-location-people'),
        logo_sliders: $('.block-logo-slider'),
        media_text_sliders: $('.block-media-text .swiper-instance'),
        quote_sliders: $('.block-quote-slider'),
        resources_slider: $('.block-resources-slider'),
        statement_with_stats: $('.block-statement-with-stats .swiper'),
        tabbed_content_sliders: $('.block-tabbed-content .swiper-instance'),
    },

    init: function() {
        // Content Columns
        if (this.settings.content_columns.length) {
            this.contentColumns();
        }
        // Expandable Content
        if (this.settings.expandable_content.length) {
            this.expandableContent();
        }
        // Featured Posts Slider
        if (this.settings.featured_posts.length) {
            this.featuredPostSlider();
        }
        // History Timeline
        if (this.settings.history_timeline_slider.length) {
            this.historyTimelineSlider();
        }
        // History Timeline - Content Slider
        if (this.settings.history_timeline_content_sliders.length) {
            this.historyTimelineContentSlider();
        }
        // Location Media & Text
        if (this.settings.location_media_text.length) {
            this.locationMediaText();
        }
        // Location People Display
        if (this.settings.location_people_display.length) {
            this.locationPeopleDisplay();
        }
        // Logo Slider
        if (this.settings.logo_sliders.length) {
            this.logoSliders();
        }
        // Media & Text Slider
        if (this.settings.media_text_sliders.length) {
            this.mediaTextSliders();
        }
        // Quote Sliders
        if (this.settings.quote_sliders.length) {
            this.quoteSliders();
        }
        // Resources Slider
        if (this.settings.resources_slider.length) {
            this.resourcesSlider();
        }
        // Statement With Stats Sliders
        if (this.settings.statement_with_stats.length) {
            this.statementWithStats();
        }
        // Tabbed Content Slider
        if (this.settings.tabbed_content_sliders.length) {
            this.tabbedContentSliders();
        }
    },

    // Content Columns
    contentColumns: function() {

        acf_blocks.settings.content_columns.each(function() {

            // Expandable Content
            $(this).find('.js-expand-content-column-button').on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    var button = $(this);
                    // Toggle Content
                    if (button.hasClass('open')) {
                        button.removeClass('open');
                        button.siblings('.expandable-content').slideUp(500);
                    } else {
                        button.addClass('open');
                        button.siblings('.expandable-content').slideDown(500);
                    }
                }
            });

        });

    },

    // Expandable Content
    expandableContent: function() {

        acf_blocks.settings.expandable_content.each(function() {

            var button = $(this).find('.js-button-to-expand');
            var content = $(this).find('.content-to-expand');

            button.on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    if (!content.hasClass('expanded')) {
                        content.addClass('expanded');
                        content.animate({
                            height: content.get(0).scrollHeight
                        }, 500, function(){
                            $(this).height('auto');
                        });
                        button.text('View Less');
                    } else {
                        content.removeClass('expanded');
                        content.animate({
                            height: 275
                        }, 500);
                        button.text('Keep Reading');
                    }
                }
            });

        });

    },

    // Featured Posts Slider
    featuredPostSlider: function() {

        // Initialize Carousel / Slider
        window.swipers = {};
        this.settings.featured_posts.each(function() {
            var slider = $(this);
            var swiper = new Swiper($(this).find('.swiper')[0], {
                allowTouchMove: false,
                effect: 'fade',
                keyboard: {
                    enabled: true,
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                pagination: {
                    clickable: true,
                    el: slider.find('.swiper-dots')[0],
                },
                slidesPerView: 1,
                speed: 500,
            });
            window.swipers[slider.data('blockId')] = swiper;
        });

        // Fix FacetWP display value color contrast
        function fixFacetWPColorContrast() {
            $('.facetwp-display-value').each(function() {
                var $el = $(this);
                // Remove inline color styles that might be added by FacetWP
                if ($el.css('color') === 'rgb(217, 221, 224)' || $el.attr('style')) {
                    $el.css('color', '');
                }
            });
        }
        // Run on page load
        fixFacetWPColorContrast();
        // Run after FacetWP refreshes
        $(document).on('facetwp-loaded facetwp-refresh', fixFacetWPColorContrast);

        // Adjust Posts to accommodate Filters
        if(this.settings.featured_posts.filter('.is--influenced-by-filters').length) {
            $(document).on('facetwp-refresh', function() {
                this.settings.featured_posts.filter('.is--influenced-by-filters').each(function() {
                    var blockInstance = $(this);
                    var request = {
                        config: blockInstance.data('config'),
                        filters: FWP.facets
                    };
                    $.get({
                        url: '/wp-json/captrust/v1/featured-posts',
                        data: request,
                        dataType: 'json',
                        success: function(data, status, xhr) {
                            data = JSON.parse(data);
                            blockInstance
                                .data('postCount', data.length)
                                .attr('data-post-count', data.length);
                            var swiper = window.swipers[(blockInstance.data('blockId'))];
                            swiper.removeAllSlides();
                            swiper.appendSlide(data);
                            swiper.slideTo(0, 0, false);
                            swiper.update();
                            blockInstance.removeClass('hide-slides');
                        }
                    });
                });
            }.bind(this));
        }

    },

    // History Timeline Slider
    historyTimelineSlider: function() {

        acf_blocks.settings.history_timeline_slider.each(function() {

            var slider_years = $(this).find('.timeline-years');
            var slider_main = $(this).find('.timeline-slider');
            var controls_main = $(this).find('.timeline-slider-controls');

            // Main Timeline Slider
            var swiper = new Swiper($(this).find('.timeline-slider')[0], {
                allowTouchMove: false,
                autoHeight: true,
                effect: 'creative',
                creativeEffect: {
                    limitProgress: 1,
                    prev: {
                        opacity: 0,
                        origin: 'center',
                        scale: 0.9,
                        translate: [0, 0, -100],
                    },
                    next: {
                        opacity: 1,
                        scale: 1,
                        translate: ['100%', 0, 0],
                    },
                },
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: '.timeline-slider-controls .swiper-arrow.next',
                    prevEl: '.timeline-slider-controls .swiper-arrow.prev',
                },
                slidesPerView: 1,
                speed: 500,
                breakpoints: {
                    960: {
                        effect: 'creative',
                        creativeEffect: {
                            limitProgress: 1,
                            prev: {
                                opacity: 0,
                                origin: 'center',
                                scale: 0.9,
                                translate: [0, 0, -100],
                            },
                            next: {
                                opacity: 1,
                                scale: 1,
                                translate: [0, '-100%', 0],
                            },
                        },
                    },
                },
            });

            // Year Controls Slider
            var swiperYears = new Swiper($(this).find('.timeline-years')[0], {
                allowTouchMove: true,
                freeMode: {
                    enabled: true,
                    sticky: true,
                },
                navigation: {
                    nextEl: '.timeline-years-controls .swiper-arrow.next',
                    prevEl: '.timeline-years-controls .swiper-arrow.prev',
                },
                slidesPerGroup: 5,
                slidesPerView: 5,
                speed: 500,
                breakpoints: {
                    640: {
                        allowTouchMove: false,
                        slidesPerGroup: 10,
                        slidesPerView: 10,
                    },
                    960: {
                        slidesPerGroup: 15,
                        slidesPerView: 15,
                    },
                },
            });

            // Main Timeline Slider
            swiper.on('slideChangeTransitionStart', function() {
                // Total slides
                var total_slides = swiper.slides.length;
                // Current active slide index
                var current_index = swiper.realIndex;

                // Update which controls to display
                if (current_index == 0) {
                    // No previous year
                    controls_main.attr('data-control-display', 'next');
                } else if (current_index == total_slides - 1) {
                    // No next year
                    controls_main.attr('data-control-display', 'prev');
                } else {
                    // Previous and next
                    controls_main.attr('data-control-display', 'both');
                }

                // Controls
                var previous = controls_main.find('.prev');
                var next = controls_main.find('.next');
                // Adjacent years
                var previous_year = slider_main.find('.timeline-slide.swiper-slide-prev').data('slide-year');
                var next_year = slider_main.find('.timeline-slide.swiper-slide-next').data('slide-year');

                // Update years displayed on controls
                previous.text(previous_year);
                next.text(next_year);

                // Update Year Controls Slider
                var target_year = slider_main.find('.timeline-slide.swiper-slide-active').data('slide-year');
                var target_year_index = slider_years.find('[data-target-year=' + target_year + ']').index();
                swiperYears.slideTo(target_year_index);
                slider_years.find('.active').removeClass('active');
                slider_years.find('[data-target-year=' + target_year + ']').addClass('active');
            });

            // Year Controls
            $(this).find('.timeline-years .has-content').on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    // Get the target year
                    var target_year = $(this).data('target-year');
                    // Get the slide for that year
                    var target_year_slide = $(this).closest('section').find('[data-slide-year=' + target_year + ']').index();
                    // Go to that slide
                    swiper.slideTo(target_year_slide);
                    // Remove current active class
                    $(this).closest('.timeline-years').find('.active').removeClass('active');
                    // Update active year in timeline
                    $(this).addClass('active');
                }
            });

        });

    },

    // History Timeline Content Slider
    historyTimelineContentSlider: function() {

        acf_blocks.settings.history_timeline_content_sliders.each(function() {

            // Thumbnail Slider
            var swiperThumbs = new Swiper($(this).find('.swiper-thumbnails')[0], {
                freeMode: true,
                multipleActiveThumbs: false,
                slidesPerView: $(this).find('.swiper-thumbnails').data('slide-count'),
                spaceBetween: 5,
                watchSlidesProgress: true,
            });

            // Main Slider
            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                slidesPerView: 1,
                thumbs: {
                    swiper: swiperThumbs,
                },
            });

        });

    },

    // Location Media & Text
    locationMediaText: function() {

        // Use fitty.js to scale the location name to fill the viewport
        if ($('.location-title--main').length) {
            fitty('.location-title--main', {
                minSize: 12,
                maxSize: 90,
            });
        }

        acf_blocks.settings.location_media_text.each(function() {

            var block = $(this).closest('section');

            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: block.find('.swiper-arrow.next')[0],
                    prevEl: block.find('.swiper-arrow.prev')[0],
                },
                pagination: {
                    clickable: false,
                    el: block.find('.swiper-dots')[0],
                },
                slidesPerView: 1,
            });

        });
    },

    // Location People Grid
    locationPeopleDisplay: function() {

        acf_blocks.settings.location_people_display.each(function() {

            // Show all people after clicking the View All button
            $(this).find('.js-view-all-people').on('click keydown', function(e) {
                if (global_helpers.accessibilityButtons(e)) {
                    // Show all people
                    $(this).closest('.block-location-people').find('.hidden').removeClass('hidden');
                    // Remove button
                    $(this).closest('.view-all').remove();
                }
            });

        });

    },

    // Logo Sliders
    logoSliders: function() {

        acf_blocks.settings.logo_sliders.each(function() {

            var swiper = new Swiper($(this).find('.swiper')[0], {
                keyboard: {
                    enabled: true,
                },
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                slidesPerView: 2,
                spaceBetween: 30,
                speed: 500,
                breakpoints: {
                    640: {
                        loop: false,
                        slidesPerView: 3,
                    },
                    960: {
                        loop: false,
                        centerInsufficientSlides: true,
                        slidesPerView: 'auto',
                    },
                    1280: {
                        loop: false,
                        centerInsufficientSlides: true,
                        slidesPerView: 'auto',
                        spaceBetween: 60,
                    },
                },
            });

        });

    },

    // Media & Text Sliders
    mediaTextSliders: function() {

        acf_blocks.settings.media_text_sliders.each(function() {

            // Thumbnail Slider
            var swiperThumbs = new Swiper($(this).find('.swiper-thumbnails')[0], {
                freeMode: true,
                multipleActiveThumbs: false,
                slidesPerView: $(this).find('.swiper-thumbnails').data('slide-count'),
                spaceBetween: 5,
                watchSlidesProgress: true,
            });

            // Main Slider
            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                slidesPerView: 1,
                thumbs: {
                    swiper: swiperThumbs,
                },
            });

        });

    },

    // Quote Slider
    quoteSliders: function() {

        acf_blocks.settings.quote_sliders.each(function() {

            var slider = $(this);

            var swiper = new Swiper(slider.find('.swiper')[0], {
                effect: 'fade',
                keyboard: {
                    enabled: true,
                },
                loop: true,
                navigation: {
                    nextEl: slider.find('.swiper-arrow.next')[0],
                    prevEl: slider.find('.swiper-arrow.prev')[0],
                },
                pagination: {
                    clickable: false,
                    el: slider.find('.swiper-dots')[0],
                },
                slidesPerView: 1,
            });

        });

    },

    // Resources Slider
    resourcesSlider: function() {

        window.swipers = {};

        acf_blocks.settings.resources_slider.each(function() {

            var slider = $(this);

            var swiper = new Swiper($(this).find('.swiper')[0], {
                effect: 'creative',
                creativeEffect: {
                    limitProgress: 3,
                    prev: {
                        opacity: 0,
                        origin: 'center',
                        scale: 0.9,
                        translate: [0, 0, -100],
                    },
                    next: {
                        opacity: 1,
                        scale: 1,
                        translate: ['100%', 0, 0],
                    },
                },
                keyboard: {
                    enabled: true,
                },
                loop: true,
                loopedSlides: 2,
                navigation: {
                    nextEl: slider.find('.swiper-arrow.next')[0],
                    prevEl: slider.find('.swiper-arrow.prev')[0],
                },
                pagination: {
                    clickable: false,
                    el: slider.find('.swiper-dots')[0],
                },
                slidesPerView: 'auto',
                speed: 500,
            });

            window.swipers[slider.data('blockId')] = swiper;

        });

        // Update Posts within User-Influenced Components
        $('.js-resources-slider.is--influenceable').each(function() {
            var blockInstance = $(this);
            if (Cookies.get('wordpress_captrust_visitor')) {
                var request = { config: blockInstance.data('config') };
                $.get({
                    url: '/wp-json/captrust/v1/resources-slider-posts',
                    data: request,
                    dataType: 'json',
                    success: function($data) {
                        $data = JSON.parse($data);
                        var swiper = window.swipers[(blockInstance.data('blockId'))];
                        swiper.removeAllSlides();
                        swiper.appendSlide($data);
                        swiper.slideTo(0, 0, false);
                        swiper.update();
                        blockInstance.removeClass('hide-slides');
                    }
                });
            } else {
                blockInstance.removeClass('hide-slides');
            }
        });

    },

    // Statement With Stats
    statementWithStats: function() {

        acf_blocks.settings.statement_with_stats.each(function() {

            var swiper = new Swiper($(this)[0], {
                enabled: true,
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                pagination: {
                    clickable: false,
                    el: '.swiper-dots',
                },
                slidesPerView: 1,
                breakpoints: {
                    1280: {
                        enabled: false,
                        slidesPerView: 4,
                    },
                },
            });

        });

    },

    // Tabbed Content Sliders
    tabbedContentSliders: function() {

        acf_blocks.settings.tabbed_content_sliders.each(function() {

            // Thumbnail Slider
            var swiperThumbs = new Swiper($(this).find('.swiper-thumbnails')[0], {
                freeMode: true,
                multipleActiveThumbs: false,
                slidesPerView: $(this).find('.swiper-thumbnails').data('slide-count'),
                spaceBetween: 5,
                watchSlidesProgress: true,
            });

            // Main Slider
            var swiper = new Swiper($(this)[0], {
                loop: true,
                navigation: {
                    nextEl: '.swiper-arrow.next',
                    prevEl: '.swiper-arrow.prev',
                },
                slidesPerView: 1,
                thumbs: {
                    swiper: swiperThumbs,
                },
            });

        });

    },

};
acf_blocks.init();